<template>
  <main class="main" role="main">
    <div class="main_con">
      <div class="notice_list" v-if="articles.content.length > 0">
        <ul class="notice_list_ul">
          <li
            class="notice_list_li pnt"
            v-for="(item, index) in articles.content"
            v-bind:key="index"
          >
            <div @click="readArticle(item.id)">
              <div class="notice_list_ttl">{{ item.title }}</div>
              <div class="notice_list_date">{{ item.createdAt }}</div>
            </div>
          </li>
        </ul>
      </div>

      <div class="empty_wrap" v-else>
        <div class="empty ready">
          <!--'기본: ', '준비중: ready', '결과없음: result'-->
          <div class="msg">
            <div>{{ name }}를 준비 중입니다.</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapState, mapGetters } from '@common/store/modules/board';
import * as types from '@common/store/modules/board/types';

export default {
  data() {
    return {
      name:
        this.$route.query.boardId == 'NOTICE_CUSTOMER'
          ? '공지'
          : '자주 묻는 질문',
      articleName:
        this.$route.query.boardId == 'NOTICE_CUSTOMER'
          ? 'Notice.Article'
          : 'FAQ.Article',
    };
  },
  async created() {
    await this.resetArticle();
    await this.fetchBoard(this.$route.query.boardId);
  },
  computed: {
    ...mapGetters({
      articles: types.ARTICLE_LIST,
    }),
  },
  methods: {
    ...mapActions([types.FETCH_ARTICLE_LIST, types.BOARD_ARTICLES_RESET_STATE]),
    async resetArticle() {
      await this[types.BOARD_ARTICLES_RESET_STATE];
    },
    async fetchBoard(boardId) {
      const param = {
        boardId: boardId,
      };
      if (param.boardId) {
        await this[types.FETCH_ARTICLE_LIST](param);
      }
    },
    readArticle(id) {
      this.$router.push({
        name: this.articleName,
        params: { id: id },
      });
    },
  },
};
</script>
